const firebaseConfig = {
  apiKey: 'AIzaSyB_9gldZuN05SsBpPq4uZl39BdTD9DvHIg',
  authDomain: 'simple-firebase-authenti-60715.firebaseapp.com',
  projectId: 'simple-firebase-authenti-60715',
  storageBucket: 'simple-firebase-authenti-60715.appspot.com',
  messagingSenderId: '435766603225',
  appId: '1:435766603225:web:0fc216c1d865d7b8cc3dc8',
};

export default firebaseConfig;
